import { type FC, useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { PageLoader } from 'src/components/PageLoader';
import { UserHelpRequest } from 'src/components/UserHelpRequest';
import { useCurrentUser } from 'src/lib/customHooks/useCurrentUser';
import { sendPageViewEvent } from 'src/lib/googleAnalytics';
import { resolveRedirectPath } from 'src/lib/resolveRedirectPath';
import { useStore } from 'src/store/reducers';
import { Header } from '../components/Headers/Header';

const publicRoutes = [
  /^\/auth\/login$/,
  /^\/auth\/logout$/,
  /^\/auth\/register$/,
  /^\/auth\/reset-password$/,
  /^\/auth\/forgot-password$/,
  /^\/auth\/confirm-email$/,
  /^\/app$/,
  /^\/app\/redeem_key$/,
  /^\/app\/[^/]+$/,
  /^\/app\/[^/]+\/redeem_key$/,
  /^\/timing\/[^/]+$/,
  /^\/safemap\/[^/]+$/,
];

export const RootView: FC = () => {
  const currentUser = useCurrentUser();
  const isLoadingCurrentUser = useStore((s) => s.users.isLoadingCurrentUser);
  const isAuthenticated = currentUser != null;
  const location = useLocation();

  useEffect(() => {
    sendPageViewEvent(location);
  }, [location]);

  if (isLoadingCurrentUser) return <PageLoader />;
  if (isAuthenticated && location.pathname === '/auth/login') {
    return <Navigate to={resolveRedirectPath(location.state)} replace />;
  }
  const fullPath = location.pathname + location.search;
  if (!isAuthenticated && location.pathname === '/admin/events/new') {
    return <Navigate to="/auth/register" replace state={{ nextPathname: fullPath }} />;
  }
  if (!isAuthenticated && !publicRoutes.some((route) => route.test(location.pathname))) {
    return <Navigate to="/auth/login" replace state={{ nextPathname: fullPath }} />;
  }

  return (
    <>
      <Header />
      <Outlet />
      <UserHelpRequest />
    </>
  );
};
